export function objectToUrl(object: any) {
    let url = '';
    for (var propertyName in object) {
        const value = object[propertyName];
        // preparar valor para url
        const urlValue = value !== undefined && value !== null
              ? encodeURIComponent(value)
              : '';
        url += urlValue
              ? (url ? '&' : '') + `${propertyName}=${urlValue}`
              : '';
    }
    return url ? `?${url}` : '';
}